import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, SelectPicker, Table } from 'rsuite'
import PageToolbar from '../components/PageToolbar'
import TopLevelNav from '../components/TopLevelNav'
import { numberThousandSeparator } from '../utils/formatterUtil'
import ProjectChart1 from '../widgets/dashboard/ProjectChart1'
import ProjectCusterDashboard from '../widgets/dashboard/ProjectCusterDashboard'
import Profile from '../widgets/dashboard/Profile'
import ProjectCost from '../widgets/dashboard/ProjectCost'
import ProjectTableView from '../widgets/dashboard/ProjectTableView'
import ProjectBudgetDisbursement from '../widgets/dashboard/ProjectBudgetDisbursement'
import ProjectDashboard2 from '../widgets/dashboard/ProjectDashboard2'

export default function ExEcharts() {
  return (
    <div className="custom-dashboard">
      <TopLevelNav />
      <PageToolbar />
      <Row style={{ marginTop: 25, marginBottom: 15 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <Profile />
        </Col>
      </Row>

      <Row style={{ marginBottom: 15 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ProjectChart1 />
        </Col>
      </Row>
      <Row style={{ marginBottom: 15 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ProjectCost />
        </Col>
      </Row>
      <Row style={{ marginBottom: 15 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ProjectCusterDashboard />
        </Col>
      </Row>

      <Row style={{ marginBottom: 15 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ProjectTableView />
        </Col>
      </Row>

      <Row style={{ marginBottom: 15 }}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ProjectBudgetDisbursement />
        </Col>
      </Row>
    </div>
  )
}
